import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6dc990bd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 1 }
const _hoisted_2 = { class: "client-skin-options" }
const _hoisted_3 = ["aria-pressed", "onClick"]
const _hoisted_4 = {
  key: 0,
  "aria-hidden": "true"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("button", {
      type: "button",
      class: _normalizeClass(["client-skin-entry", {'icon-only':_ctx.iconOnly}]),
      "aria-label": "皮肤",
      title: "皮肤",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openPicker && _ctx.openPicker(...args)))
    }, [
      (_ctx.iconOnly)
        ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 0,
            icon: "client-skin"
          }))
        : (_openBlock(), _createElementBlock("span", _hoisted_1, "皮肤"))
    ], 2),
    _createVNode(_component_a_modal, {
      visible: _ctx.visible,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.visible) = $event)),
      title: "选择皮肤",
      footer: null,
      width: 480
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.skins, (skin) => {
            return (_openBlock(), _createElementBlock("button", {
              key: skin.id,
              type: "button",
              "aria-pressed": _ctx.selected===skin.id,
              onClick: ($event: any) => (_ctx.choose(skin.id))
            }, [
              _createElementVNode("span", {
                class: "swatch",
                style: _normalizeStyle({background:skin.color}),
                "aria-hidden": "true"
              }, null, 4),
              _createElementVNode("span", null, _toDisplayString(skin.name), 1),
              (_ctx.selected===skin.id)
                ? (_openBlock(), _createElementBlock("span", _hoisted_4, "✓"))
                : _createCommentVNode("", true)
            ], 8, _hoisted_3))
          }), 128))
        ]),
        _createVNode(_component_a_button, {
          class: "restore-shop-skin",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.choose(null)))
        }, {
          default: _withCtx(() => [
            _createTextVNode("恢复店铺默认")
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}